module.exports = __webpack_public_path__ + "media/images/page/scene05-6e8f54bf2fd6c6d672205d87d78e5bc4.jpg";